import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import * as MenuListUI from 'components/MenuList';
import PopoverCard from 'components/PopoverCard';
import { useMenuContext } from './Menu';
import { jsx as _jsx } from "react/jsx-runtime";
function MenuList(_ref) {
  var children = _ref.children;
  var _useMenuContext = useMenuContext(),
    popover = _useMenuContext.popover,
    menuListProps = _useMenuContext.menuListProps;
  return /*#__PURE__*/_jsx(PopoverCard, _objectSpread(_objectSpread({
    renderWhenClosed: true,
    renderInPlace: false,
    isOpen: popover.isOpen
  }, popover.props), {}, {
    ref: popover.setRef,
    arrow: popover.arrow,
    children: /*#__PURE__*/_jsx(MenuListUI.Wrapper, _objectSpread(_objectSpread({
      as: "div"
    }, menuListProps), {}, {
      children: children
    }))
  }));
}
export default MenuList;